import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {noResultsTemplate, emptyTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');


export default class CompaniesFilesEdit {

  constructor() {}

  render() {
    let activeUploads = 0;
    const recordId = $('.company-documents-filepicker').attr('data-record-id');

    // Number display
    NumberDisplay();

    // Function to check if all file uploads are complete
    function checkIfAllUploadsComplete() {
      if (activeUploads === 0) {
        ToastCustom('Uploads Complete', 'All files have been successfully uploaded.', 5000);
        $('.spinner-container').remove();
        $('.modal-body').css('opacity', 1);
      }
    }

    // Upload file
    $('.company-documents-filepicker').each(function(i, elem) {
      let fileInput     = $(elem);
      let filePicker    = $(this);
      let env           = fileInput.data("env");
      fileInput.fileupload({
        fileInput:        fileInput,
        url:              fileInput.data('url'),
        type:             'POST',
        autoUpload:       true,
        formData:         fileInput.data('form-data'),
        paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
        dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
        replaceFileInput: false,

        // Add file progress bars
        add: function(e, data) {
          $('.file-upload-progress').removeClass('d-none');
          activeUploads += data.files.length;
          data.contexts = [];

          $.each(data.files, function(index, file) {

            // Create a new progress bar for this file
            let progressBar = $("<div class='bar'></div>");
            let barContainer = $("<div class='progress mb-2' style='height: 20px;'></div>").append(progressBar);

            // Optional: show filename
            let label = $("<div class='small text-muted mb-1'></div>").text(file.name);
            $('.file-upload-progress').append(label, barContainer);

            // Style bar
            progressBar
              .css('background', '#8c81d1')
              .css('width', '0%')
              .css('display', 'block')
              .css('height', '20px');

            // Store progressBar on context for this file
            data.contexts.push(progressBar);

          });

          // Begin upload
          data.submit();
        },

        progress: function(e, data) {

          // Progress per file
          if (data.contexts) {
            let progress = parseInt(data.loaded / data.total * 100, 10);
            data.contexts.forEach(function(progressBar) {
              progressBar.css('width', progress + '%');
            });
          }

          // If all at 100%, spinner
          let percents = [];
          $('.bar').each(function() {
            let barWidth = $(this).css('width').replace('px','');
            let progWidth = $(this).closest('.progress').css('width').replace('px','');
            percents.push(parseInt(barWidth / progWidth * 100, 10));
          })
          let min = Math.min.apply(Math, percents);
          if (min === 100) {
            $('.modal-body').css('opacity', 0.2);
            Spinner($('.modal'));
          }

        },

        done: function(e, data) {
          let key = $(data.jqXHR.responseXML).find("Key").text();
          let surveyId = fileInput.attr('data-survey-id');

          fileInput.closest('.filepicker-container .filepicker-label').addClass('opaque');
          Spinner(fileInput.closest('.filepicker-container'));

          let url = '/companies/' + recordId + '/files.json';
          let formData = {file: {key: key}};

          $.ajax({
            type: 'POST',
            url: url,
            dataType: "application/json",
            data: formData,
            complete(result) { 
              activeUploads--;
              checkIfAllUploadsComplete();
            },
          });

        },

        fail: function(e, data) {
          if (data.contexts) {
            data.contexts.forEach(function(progressBar) {
              progressBar
                .css("background", "red")
                .text("Failed");
            });
          }
        }

      });

    });

    // On paste of a link, create a file record
    $('#source_url').on('input', function() {
      let link = $(this).val();

      // If not an HTML web page (e.g., if a PDF), show toast to let user know can only be HTML
      // Also block if the URL contains a file extension (e.g., .pdf, .docx, .xlsx, .zip, .png, .jpg, etc.)
      let pattern = /^https?:\/\/.+/i;
      let extensionPattern = /\/[^\/?#]+\.(pdf|docx?|xlsx?|pptx?|zip|rar|png|jpe?g|gif|csv|txt|rtf|xml|json|js|css)(\?|#|$)/i;
      if (link.length > 0 && (!pattern.test(link) || extensionPattern.test(link))) {
        link = '';
        $(this).val('');
        let title = 'Invalid Link';
        let text = 'Please enter a valid URL. Only HTML web page links (not others such as PDFs) are supported.';
        let length = 5000;
        ToastCustom(title, text, length);

      } else if (link.length > 0) {
        let url = '/companies/' + recordId + '/files.json';
        let formData = {link: {source_url: link}};
        $('.modal-body').css('opacity', 0.2);
        Spinner($('.modal'));
        $.ajax({
          type: 'POST',
          url: url,
          dataType: "application/json",
          data: formData,
          complete(result) { 
            // When complete, let user know processing has started
            let title = 'Link Submitted';
            let text = 'The link has been submitted and is being processed. Feel free to add more links or close the modal.';
            let length = 5000;
            ToastCustom(title, text, length);
            // Add to list of added links
            $('#addedLinks').append(`
              <div class="d-flex align-items-center mb-2">
                <a href="${link}" target="_blank" class="mr-3">${link}</a>
                <span class="text-muted">Added</span>
              </div>
            `);
            $('.modal-body').css('opacity', 1);
            $('.spinner-container').remove();
            $('#source_url').val('');
          },
        });
      }
    });

    // Auto focus on typeahead when open a dropdown
    $('.dropdown').on('shown.bs.dropdown', function () {
      let input = $(this).find('input');
      if (typeof input !== 'undefined') {
        input.focus();
      }
    })

    // Private files
    $('.select-privacy-type').change(function() {
      let pt = $(this).val();
      if (pt === 'private') {
        $('.private-file').removeClass('d-none');
      } else {
        $('.private-file').addClass('d-none');
      }
    })

    // Search accounts
    filterTypeahead('.file-accounts-typeahead', 'accounts', '/accounts?', 143, 'generic');

    // On select
    $('.file-accounts-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      $('.hidden-account-id').val(suggestion.value);
      $('.hidden-destroy').val(false);
    });

    // Add account share
    $('.add-shared-account').click(function() {
      let url = window.location.href.split('?')[0];
      let params = {};
      params['title'] = $('#company_file_title').val();
      params['date'] = $('#company_file_date').val();
      params['privacy_type'] = 'private';

      // Add account ids
      let accountIds = []
      $.each( $('.hidden-account-id'), function(i,a) {
        let val = $(a).val();
        accountIds.push(val);
      })
      params['account_ids'] = accountIds

      // Re-load
      Turbo.visit(url + '?' + $.param(params));

    });

    // Remove account share
    $('.remove-account-id').click(function() {
      let container = $(this).closest('.shared-account');
      let persisted = container.attr('data-persisted');
      if (persisted === 'true') {
        container.find('.hidden-destroy').val(true);
      } else {
        container.remove();
      }
    })


  }

}